import {
  DerivativesClosedPositionProjection,
  DerivativesOpenedPositionProjection,
  DerivativesOrderProjection,
} from 'common/api/autogenerated/trading-gateway';

import { AssetsHashMap, GroupsHashMap } from 'common/types';

import { OrderBookDto } from 'components/OrderBook/types';

export interface FuturePosition extends DerivativesOpenedPositionProjection {
  pnl?: number;
  pnlFormated?: string;
  pnlPercentage?: number;
  pnlPercentageFormated?: string;
}

export const initialState: {
  derivatives: AssetsHashMap;
  groups: GroupsHashMap;
  favorites: string[];
  loading: {
    pairs: boolean;
    pairsInitial: boolean;
    groups: boolean;
    groupsInitial: boolean;
    favorites: boolean;
    favoritesInitial: boolean;
    info: boolean;
    orders: boolean;
    ordersInitial: boolean;
    ordersClosed: boolean;
    ordersClosedInitial: boolean;
    positions: boolean;
    positionsInitial: boolean;
    history: boolean;
    historyInitial: boolean;
    inUseTransactions: boolean;
  };
  inUseTransactions: {
    lastSettlementCurrency: string;
    orders: DerivativesOrderProjection[];
    positions: DerivativesOpenedPositionProjection[];
  };
  orderbook: {
    [key: string]: OrderBookDto;
  };
  orders: DerivativesOrderProjection[];
  closedOrders: DerivativesOrderProjection[];
  latestClosedOrder?: DerivativesOrderProjection | null;
  positions: FuturePosition[];
  history: DerivativesClosedPositionProjection[];
  orderIsEditing: number | null;
} = {
  derivatives: {},
  groups: {},
  favorites: [],
  loading: {
    pairs: true,
    pairsInitial: true,
    groups: true,
    groupsInitial: true,
    favorites: true,
    favoritesInitial: true,
    info: false,
    orders: false,
    ordersInitial: true,
    ordersClosed: false,
    ordersClosedInitial: true,
    positions: false,
    positionsInitial: true,
    history: false,
    historyInitial: true,
    inUseTransactions: false,
  },
  inUseTransactions: {
    lastSettlementCurrency: '',
    orders: [],
    positions: [],
  },
  orderbook: {},
  orders: [],
  closedOrders: [],
  latestClosedOrder: null,
  positions: [],
  history: [],
  orderIsEditing: null,
};
